import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useApiKeyCache } from './cache'
import { toResponseError, type ApiKeyAddInput, type ApiKeyAddSuccess } from '@terros/common'

export function useAddApiKey(): AddHookResponse<ApiKeyAddInput, ApiKeyAddSuccess> {
  const mutation = useTantalimMutation<ApiKeyAddInput, ApiKeyAddSuccess>({
    url: '/apikey/add',
  })
  const cache = useApiKeyCache()

  async function add(input: ApiKeyAddInput): Promise<ApiKeyAddSuccess> {
    try {
      const added = await mutation.mutateAsync(input)
      cache.clearList()
      return added
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
